import { ImageType } from './model/image-type.enum';

export class ExecutingTask {
  public id?: string;
  public task?: string;
  public statusImage?: ImageType;
  public startTime?: number;
  public duration?: number;
  constructor(
    id?: string,
    task?: string,
    statusImage?: ImageType,
    startTime?: number,
    duration?: number
  ) {
    this.id = id;
    this.task = task;
    this.statusImage = statusImage;
    this.startTime = startTime;
    this.duration = duration;
  }
}
